import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["checked"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", null, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'SuggestedValue',
  props: ['value', 'selected'],
  emits: ['chooseValue'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    class: "pay-select-summ-item",
    key: __props.value,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('chooseValue', __props.value)))
  }, [
    _createElementVNode("input", {
      type: "radio",
      checked: __props.selected === __props.value
    }, null, 8, _hoisted_1),
    _hoisted_2,
    _createElementVNode("span", null, _toDisplayString(__props.value), 1)
  ]))
}
}

})